<template>
  <b-card
    no-body
    class="p-2 set-banner-card container-card"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-end"
      >
        <add-button
          v-if="getPermissionModule('Banner').adjust"
          :btn-label="$i18n.t('banner.set')"
          @click.native="$router.push('/banner/set/Banner_Set/create')"
        />
      </b-col>
      <b-col
        cols="12"
        class="d-flex justify-content-end my-1"
      >
        <div class="banner-search-container">
          <search :on-search-input="onSearchBanner" />
        </div>
      </b-col>
      <b-col cols="12">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <!-- <b-table
              :fields="fields"
              :items="setBannerTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              class="set-banner-table"
              @sort-changed="sortingChanged"
            > -->
            <b-table
              :fields="fields"
              :items="setBannerTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              class="default-static-table-vertical"
              @sort-changed="sortingChanged"
            >
              <template #cell(description)="data">
                <span>{{ data.item.description || '-' }}</span>
              </template>
              <template #cell(valid_from)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_from)
                }}</span>
              </template>
              <template #cell(valid_through)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_through)
                }}</span>
              </template>
              <template #cell(updatetime)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.updatetime)
                }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-if="data.item.status"
                    icon="CircleIcon"
                    class="active-icon mr-2"
                  />

                  <span>{{ resolveBannerStatusLabel(data.item.status) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CircleIcon"
                    class="inActive-icon mr-2"
                  />
                  <span class="inActive-label">{{
                    resolveBannerStatusLabel(data.item.status)
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <action-group
                  v-if="getPermissionModule('Banner').adjust"
                  :resolve-action="resolveBannerAction"
                  :set-action-list="setBannerActionList"
                  :item-data="data.item"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <assign-banner-modal
      v-if="formModal.assignModal"
      is-set-banner
      :banner-id="assignBannerConfig.setBannerId"
      @onCloseModal="closeModal"
    />
  </b-card>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from 'bootstrap-vue'
import KebabIcon from '@/@core/components/svg/common/Kebeb.vue'
import EditIcon from '@/@core/components/svg/common/Edit.vue'
import AssignBannerGroupIcon from '@/@core/components/svg/common/FileRightArrow.vue'
import DeleteIcon from '@/@core/components/svg/common/Trash.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'
import AddButton from '@/views/components/button/AddButton.vue'
import Search from '@/views/components/search/Search.vue'
import ActionGroup from '@/views/components/table-action-group/ActionGroup.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import AssignBannerModal from '../banner-list/components/AssignBannerModal.vue'

import useSetBanner from './hooks/useSetBanner'

export default {
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BButton,
    BDropdown,
    BDropdownItem,
    KebabIcon,
    EditIcon,
    AssignBannerGroupIcon,
    DeleteIcon,
    AddButton,
    Search,
    ActionGroup,
    BSpinner,
    CardNoItem,
    AssignBannerModal,
    PaginationWithReorder,
  },
  setup() {
    const {
      fields,
      setBannerTable,
      setBannerActionList,
      pagination,
      loading,
      assignBannerConfig,
      resolveDateWithSeperator,
      resolveBannerStatusLabel,
      resolveBannerAction,
      onPageChange,
      onSearchBanner,
      sortingChanged,
      closeModal,
      formModal,
      getPermissionModule
    } = useSetBanner()

    return {
      fields,
      setBannerTable,
      setBannerActionList,
      pagination,
      loading,
      assignBannerConfig,
      resolveDateWithSeperator,
      resolveBannerStatusLabel,
      resolveBannerAction,
      onPageChange,
      onSearchBanner,
      sortingChanged,
      closeModal,
      formModal,
      getPermissionModule
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/override-styles/status.css';
@import '~@/assets/css/pages/banner/banner-table.css';
@import '~@/assets/css/pages/banner/set-banner.css';
</style>
